export const DATE_BACKEND_FORMAT = 'yyyy-MM-dd';
